import { Game } from '../../../interfaces/Games.interface';

type CompetitionCoverage = 'FULL' | 'PARTIAL' | 'NONE';

/**
 * returns for a specific competition and for games the coverage
 * @param {string} competition
 * @param {Game[]} gamesFromSelectedTeams
 * @param {Game[]}  totalCoveredGames
 * @returns {CompetitionCoverage}
 */
export const getCompetitionCoverage = (
  competition: string,
  gamesFromSelectedTeams: Game[],
  totalCoveredGames: Game[]
): CompetitionCoverage => {
  const gamesInCompetition = gamesFromSelectedTeams.filter(
    (game) => game.tournament_name === competition
  );
  const coveredInCompetition = totalCoveredGames.filter(
    (game) => game.tournament_name === competition
  );

  if (coveredInCompetition.length === gamesInCompetition.length) {
    return 'FULL';
  }
  if (coveredInCompetition.length > 0) {
    return 'PARTIAL';
  }
  return 'NONE';
};
